import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { marketingI18n } from "../content/homeMarketing";
import useScrollAnimate from "../hooks/useScrollAnimate";
import FaqSection from "./marketing/FaqSection";
import MarketingPageIntro from "./marketing/MarketingPageIntro";
import "./Home.css";
import "./MarketingPages.css";
import "./FaqPage.css";

export default function FaqPage() {
  const { lang } = useLanguage();
  const t = marketingI18n[lang];
  useScrollAnimate([lang]);

  return (
    <div className={`marketing-page faq-page ${lang === "ar" ? "rtl" : ""}`} dir={lang === "ar" ? "rtl" : "ltr"}>
      <MarketingPageIntro variant="faq" page={t.pages.faq} lang={lang} layout="split" />
      <FaqSection t={t} lang={lang} showContactCard hidePageTitle pageLayout />

      <section className="faq-page-cta-section">
        <div className="container faq-page-cta-inner scroll-animate from-bottom delay-2">
          <h2 className="faq-page-cta-title">{t.faqContactTitle}</h2>
          <p className="faq-page-cta-desc">{t.faqSubtitleText}</p>
          <div className="faq-page-cta-actions">
            <Link to="/contact" className="faq-page-cta-btn faq-page-cta-btn--primary">
              {lang === "ar" ? "تواصل معنا" : "Contact us"}
            </Link>
            <Link to="/support" className="faq-page-cta-btn faq-page-cta-btn--secondary">
              {lang === "ar" ? "اسأل المساعد" : "Ask the assistant"}
            </Link>
          </div>
        </div>
      </section>

      <div className="section-wave section-wave--light" aria-hidden="true" />
    </div>
  );
}
